import React, { useCallback, useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { IStore } from 'store/reducers';
import { AppViews } from 'endpoints';
import moment from 'moment';
import jwt from 'jwt-decode';

import { logoutAgency } from 'store/actions';

const AgencyGuard: React.FC = ({ children }) => {
  const dispatch = useDispatch();

  const { token }: any = useSelector<IStore>((state) => state.authAgency);

  const hasToken = useCallback(() => {
    if (!token) {
      dispatch(logoutAgency());
      window.location.href = AppViews.AGENCY_LOGIN;
    }
  }, []);

  const hasExpired = useCallback(() => {
    if (token) {
      const tokendecoded: any = jwt(token);
      const dateNow = moment().format('YYYY-MM-DD HH:mm');
      const dateExpired = moment.unix(tokendecoded.exp).format('YYYY-MM-DD HH:mm');
      const isExpired = moment(dateExpired).isBefore(dateNow);
      if (isExpired) {
        dispatch(logoutAgency());
        window.location.href = AppViews.AGENCY_LOGIN;
      }
    }
  }, [token]);

  useEffect(() => {
    hasToken();
    hasExpired();
  }, []);

  return <>{children}</>;
};

export default AgencyGuard;
